module.exports = __webpack_public_path__ + "media/images/promo/bg_card_5-3de701c4a2b4d6358dfe257487974bd1.jpg";